import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import * as Request from '../tgccRequest';
import {
    DEFAULT_ADULT_SIZE_NAMES,
    getRosterSizeTotals,
    resolveRosterSizeColumns,
    RosterSizeColumn,
} from './rosterSizeColumns';

const wrapperStyle: React.CSSProperties = {
    borderCollapse: 'separate',
    borderSpacing: '6px',
    fontFamily: 'CenturyGothic',
    backgroundColor:'white',
    fontSize: '12px',
    padding: '20px',
    overflowX: 'hidden',
    overflowY: 'auto',
    minHeight: '200px',
    maxWidth: '90%',
    margin: "0 auto 20px auto",
    textTransform: "uppercase",
    borderRadius:'10px',
    color: Tgcc.Styles.darkTextColor,
    '@media (max-width:414px)': {
        overflowX:'scroll',
    }
}

const rowStyle: React.CSSProperties = {
    display: 'table-row',
}

const dataStyle: React.CSSProperties = {
    display: 'table-cell',
    backgroundColor: 'white',
    padding: '3px',
    margin: '3px',
    border:'1px solid #E9E6E6',
    fontFamily:'BarlowMedium'
}

const rosterHdrStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    fontSize: '12px',
    justifyContent: 'space-between',
    alignContent: 'center',
    marginBottom: '5px'
}
const hdrElementStyle: React.CSSProperties = {
    display: 'flex'
}
const hdrLabelStyle: React.CSSProperties = {
    textTransform: 'uppercase',
    marginRight: '4px',
    fontFamily:'BarlowMedium'
}
const hdrDataStyle: React.CSSProperties = {
    textTransform: 'none',
    fontWeight: 900,
    fontFamily:'BarlowMedium'
}
const eventhdrDataStyle: React.CSSProperties = {
    textTransform: 'none',
    fontWeight: 900,
    color:'#E27558',
    fontFamily:'BarlowMedium'
}

let nameStyle = Object.assign({}, dataStyle, {width: '100px'});
let nameHdrStyle = Object.assign({}, nameStyle, {backgroundColor: 'transparent', fontSize: '9px'});
let numStyle = Object.assign({}, dataStyle, {width: '13px', textAlign:'right'});
let numHdrStyle = Object.assign({}, numStyle, {backgroundColor: 'transparent', fontSize: '9px'});
let emailStyle = Object.assign({}, dataStyle, {width: '175px'});
let emailHdrStyle = Object.assign({}, emailStyle, {backgroundColor: 'transparent', fontSize: '12px', border:'none'});
let emptyHdrStyle = Object.assign({},numStyle,{border:'none'})

let noDataStyle: CSSProperties = {
    fontSize: '25px',
    fontStyle: 'italic',
    padding: '50px',
    textAlign: 'center'
}
const totalStyle: React.CSSProperties = {
    display:'inline-block',
    marginRight:'10px',
    fontFamily:'BarlowMedium'
}
const totNumStyle: React.CSSProperties = {
    marginRight:'10px',
    fontFamily:'BarlowMedium'
}

const divTotalStyle: React.CSSProperties = {
    textAlign:'center',
    marginTop:'12px'
}

const tableStyle : React.CSSProperties = {
    display:'table',
    border:'1px solid black',
    borderRadius:'20px',
    padding:'8px'
}

const endSalesBtn: React.CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#E27558',
    height: '35px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    fontFamily:'Lulo'
}
let errorStyle=Object.assign({}, Tgcc.Styles.error, {fontSize:'15px', margin: 'auto',lineHeight:'unset',height:'unset',width:'75%',fontStyle:'unset',textTransform:'none'});


class Props extends Tgcc.BaseProps{
    rosterCode: string;
    isTBanker: boolean;
}

const RosterTypes ={
    TBanker: "TBanker",
    TVite: "TVite",
    Omega: "Omega"
};

class _MajorAccountsOrderRoster extends React.Component<Props, any>{
    state = { 
        isWaiting: false,
        rosterCode: null,
        rosterState: null,
        rosterType: null,
        rosterEvent: null,
        rosterPrice: null,
        roster: new Array(),
        activeAdultSizes: null as string[] | null,
        activeYouthSizes: null as string[] | null,
        isOneSize: false,
        error:null

    };


    init= (props: Props) => {
        if(props.state.LoginData && props.rosterCode)
            Request.getRoster(this.props.state.LoginData, props.rosterCode, this.rosterLoaded, this.loadError);
    }

    componentWillMount(){
        this.init(this.props);
    }
    
    componentWillReceiveProps(props: Props){
        this.init(props);
    }

    rosterLoaded = (data: any) => {
        this.setState({
            roster: data.roster, 
            rosterType: data.rosterType,
            rosterState: data.rosterState,
            rosterCode: data.rosterCode,
            rosterEvent: data.rosterEvent,
            rosterPrice: data.rosterPrice,
            activeAdultSizes: data.activeAdultSizes || null,
            activeYouthSizes: data.activeYouthSizes || null,
            isOneSize: !!data.isOneSize
        });
    }

    loadError = (err: any) => {
        console.log("error loading roster: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    setError = (msg: string) => {
        this.setState({error: msg, isWaiting: false}, () => {
            this.scrollPageToView("TopProofError1");
        });
        return false;
    }

    getSizeColumns = (): RosterSizeColumn[] => {
        return resolveRosterSizeColumns(
            this.state.activeAdultSizes,
            this.state.activeYouthSizes,
            this.state.isOneSize,
            DEFAULT_ADULT_SIZE_NAMES
        );
    }

    getTotals = () => getRosterSizeTotals(this.state.roster, this.getSizeColumns());

    closeRoster = () => {
        var total  = this.getTotals().Total
        if(total < 24){
            return this.setError("Order size does not meet our minimum(24 pieces).Please contact your account manager or sales@grafcow.com");
        }
        this.setState({error: null, isWaiting: true});

        if(this.state.rosterType == RosterTypes.TBanker)
            Request.closeTBankerRoster(this.props.state.LoginData, this.state.rosterCode, this.rosterClosed, this.rosterCloseError)
        else if (this.state.rosterType == RosterTypes.TVite)
            Request.closeTViteRoster(this.props.state.LoginData, this.state.rosterCode, this.rosterClosed, this.rosterCloseError)
        }

    rosterClosed = () => {
        this.setState({rosterState: "CLOSED", isWaiting: false})
    }

    rosterCloseError = (err: string) => {
        this.setState({error: err, isWaiting: false});
    }

    canClose = () => {
        return this.state.rosterState == "OPEN";
    }

    getRosterLink = () => {
        switch(this.state.rosterType){
            case RosterTypes.TBanker:
                return <a className="hoverBorder" href={Tgcc.Routes.Tbanker(this.state.rosterCode)}>{this.state.rosterCode}</a>
            case RosterTypes.Omega:
                return <a>{this.state.rosterCode}</a>
            case RosterTypes.TVite: 
                return <a className="hoverBorder" href={Tgcc.Routes.TVite(this.state.rosterCode)}>{this.state.rosterCode}</a>
            default:
                return <a>{this.state.rosterCode}</a>
        }
    }

    render(){

        if(!this.state.rosterType) 
            return <div style={wrapperStyle}>{Tgcc.workingGif}</div>;

        var roster = this.state.roster ? this.state.roster : new Array();
        var noData = roster && roster.length ? null : <div style={noDataStyle}>no roster data</div>;
        var closedStyle = Object.assign({}, Tgcc.Styles.grayButton, { cursor: 'default'});
        
        var closeRoster = this.canClose() ? <div className="hoverBorder" style={endSalesBtn} onClick={this.closeRoster}>End Online Sales</div> : <div style={closedStyle}>Roster has been closed</div>;
        closeRoster = this.state.rosterType == RosterTypes.Omega ? null : closeRoster;
        
        var rosterLink = this.getRosterLink();
        var sizeColumns = this.getSizeColumns();
        var totals = this.getTotals();
        
        if(this.state.isWaiting)
            closeRoster = Tgcc.workingGif;
        if(noData)
            closeRoster = null;

        return (
                <div style={wrapperStyle} className="campusRosterCont">
                    <div style={rosterHdrStyle} className="campusTBankerHdr">
                        <div style={hdrElementStyle}><div style={hdrLabelStyle}>{this.state.rosterType}:</div><div style={hdrDataStyle}>{rosterLink}</div></div>
                        <div style={hdrElementStyle}><div style={hdrLabelStyle}>Event:</div><div style={eventhdrDataStyle} className="campusEvtName">{this.state.rosterEvent}</div></div>
                        <div style={hdrElementStyle}><div style={hdrLabelStyle}>Price:</div><div style={hdrDataStyle}>${this.state.rosterPrice}</div></div>
                    </div>
                    <div style={tableStyle}>
                        <div style={rowStyle}>
                            <div style={emptyHdrStyle}>&nbsp;</div>
                            <div style={emptyHdrStyle}>name</div>
                            <div style={emptyHdrStyle}>&nbsp;</div>
                            <div style={emailHdrStyle}>email</div>
                            {sizeColumns.map(col => (
                                <div key={'hdr-' + col.name} style={emptyHdrStyle}>{col.header}</div>
                            ))}
                        </div>
                        {roster.map( (row: any, index: number) => {
                            return (
                                <div key={this.props.rosterCode + index} style={rowStyle}>
                                    <div style={numStyle}>{index+1}</div>
                                    <div style={nameStyle}>{row.fname}</div>
                                    <div style={nameStyle}>{row.lname}</div>
                                    <div style={emailStyle}>{row.total_Email}</div>
                                    {sizeColumns.map(col => (
                                        <div key={col.name + index} style={numStyle}>{row[col.key] || 0}</div>
                                    ))}
                                </div>
                            )
                        })}
                    </div>
                   <div style={divTotalStyle}>
                            <div style={totalStyle}>Total:<div style={totNumStyle}>{totals.Total}</div></div>
                            {sizeColumns.map(col => (
                                <div key={'tot-' + col.name} style={totalStyle}>{col.label}:<div style={totNumStyle}>{totals[col.label] || 0}</div></div>
                            ))}
                    </div>
                    <div style={ {display: 'flex', justifyContent: 'center',flexDirection:'column'} }>
                        {noData}
                        <div id="TopProofError1" style={errorStyle}>{this.state.error}</div>               

                        {closeRoster}
                    </div>
                 </div>
        )
    }
}


const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state  }
};

export var MajorAccountsOrderRoster = connect(mapStateToProps)(Radium(_MajorAccountsOrderRoster));